module.exports = __webpack_public_path__ + "static/img/127.7f6bc32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/127.png
// module id = eK2I
// module chunks = 0